import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

// A native bar button standing in for a web one (docs/HOTWIRE.md § Native
// shell). Put it on the element a tap should click — a drawer's <label>, a
// link — and the shell draws it on `data-bridge-side` (left | right).
//
//   <label for="sidebar-drawer" data-controller="bridge--button"
//          data-bridge-side="left" data-bridge-title="Menu"
//          data-bridge-ios-image="line.3.horizontal"></label>
//
// The side IS the event, so a left and a right button on one page each get
// their own reply instead of the last one connected answering for both.
export default class extends BridgeComponent {
  static component = 'button';

  connect() {
    super.connect();
    const el = this.bridgeElement;
    this.send(this.side, {
      title: el.title,
      iosImage: el.bridgeAttribute('ios-image'),
      androidImage: el.bridgeAttribute('android-image'),
    }, () => el.click());
  }

  disconnect() {
    super.disconnect();
    this.send(`${this.side}-off`);
  }

  get side() {
    return this.bridgeElement.bridgeAttribute('side') === 'left' ? 'left' : 'right';
  }
}
